import React from 'react';
import { useTranslation } from 'react-i18next';

function MonthCombo(props) {
    const months = [1,2,3,4,5,6,7,8,9,10,11,12];
    const { t } = useTranslation();
    const { handleMonthChange, month } = props;

    return (
        <select onChange={handleMonthChange} value={month} className="default_select">
            <option key="all" value="all">{t('common:options.month.all')}</option>
            {months.map((i) => 
                <option key={i} value={i}>{t(`common:options.month.${i}`)}</option>
            )}
        </select>
    );
}

export default MonthCombo;